module.exports = __webpack_public_path__ + "img/logo-nnk.6f38b319.svg";